var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"app"}},[(_vm.isDevelopment)?_c('VueBootstrapBreakpointIndicator',{staticClass:"breakpoint"}):_vm._e(),(!_vm.$route.meta?.hideNav)?_c('Navbar'):_vm._e(),_c('Modals'),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }